const isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows();
    },
  };

if (isMobile.any()) {
  // alert('is mobile !');
} else {
  $(function () {
    $("html").niceScroll();
    $("html").getNiceScroll().onResize();
  });
}

// Challenge page

if (window.location.href.includes('challenge')) {
  document.querySelector('.header').classList.add("_light");
  document.querySelector('.footer-menu').style.display = 'none';
  document.querySelector('.content-for-layout.focus-none').style.display = 'flex';
  document.querySelector('.content-for-layout.focus-none').style.alignItems = 'center';
  document.querySelector('.content-for-layout.focus-none').style.justifyContent = 'center';
  document.querySelector('.shopify-section.footer').style.background = 'transparent';
  document.querySelector('.footer__copyright').style.borderTop = '1px solid #525252';
  document.querySelectorAll('.shopify-section.footer *').forEach(item => item.style.color = '#525252');
}

if (window.location.href.includes('contact_posted=true')) {
  document.querySelector('#popup-sent').classList.add('open');
  document.querySelector('.popup-sent__btn.close-popup').addEventListener('click', e => {
    const currentUrl = window.location.href;
    const baseUrl = currentUrl.split('?')[0];
    history.replaceState(null, null, baseUrl);
  });
} 

  